import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  className?: string;
  showPrice?: boolean;
  isCheckout?: boolean;
}
export const CTAButton: React.FC<CTAButtonProps> = ({
  text = 'ACCEDER AL KIT SESIONES CLÍNICAS',
  className = '',
  showPrice = false,
  isCheckout = false
}) => {
  const handleScrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className={`flex flex-col items-center ${className}`} data-id="element-29">
      {showPrice && <div className="mb-2 text-center" data-id="element-30">
          <span className="text-gray-400 line-through text-lg mr-2" data-id="element-31">
            $49.990
          </span>
          <span className="text-gold-500 font-bold text-xl" data-id="element-32">$19.990 ARS</span>
        </div>}
      <motion.a href={isCheckout ? 'https://checkout.sectordigital.online/cart/43948465389611:1' : '#comprar'} target={isCheckout ? '_blank' : undefined} rel={isCheckout ? 'noopener noreferrer' : undefined} onClick={isCheckout ? undefined : handleScrollToPricing} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} className="bg-gold-500 hover:bg-gold-400 text-navy-900 font-bold py-4 px-8 rounded-full shadow-[0_0_20px_rgba(201,168,76,0.4)] transition-all duration-300 flex items-center justify-center gap-2 text-lg md:text-xl w-full max-w-md text-center" data-id="element-33">
        {text}
        <ArrowRight className="w-6 h-6" data-id="element-34" />
      </motion.a>
    </div>;
};